import type { ToastID } from 'vue-toastification/dist/types/types';
import type { Course } from '@/views/Courses/Create';

export default {
  course: null as Course | null,
  actionDeniedToastId: null as ToastID | null,
};
